import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description EuroExchange icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { EuroExchange } from '@sravni/design-system-icons'
 *
 * <EuroExchange />
 * ```
 */
var EuroExchange = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "EuroExchange", viewBox: "0 0 21 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#EuroExchange__a)", stroke: "currentColor" },
        React.createElement("path", { d: "M12.406 4.12c-2.59-.23-4.64 1.9-4.51 4.05.13 2.02 2.17 3.81 4.6 3.53", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }),
        React.createElement("path", { d: "M6.736 7.03h4.04M6.736 8.82h4.04", strokeWidth: "1.3", strokeMiterlimit: "10", strokeLinecap: "round" }),
        React.createElement("path", { d: "M9.786 1.047a7.223 7.223 0 0 0-4.112 1.62l-.347-.36A7.722 7.722 0 0 1 9.787.545v.502Zm1-.502c3.763.236 6.785 3.105 7.042 6.705h-.501c-.257-3.31-3.045-5.97-6.54-6.204v-.5Zm6.54 7.705h.501a7.049 7.049 0 0 1-.077.633l-.464-.111.03-.122h-.036a6.28 6.28 0 0 0 .046-.4ZM10.966 14.953a7.223 7.223 0 0 0 4.113-1.621l.35.364a7.75 7.75 0 0 1-4.463 1.758v-.501Zm-1 0v.501c-3.763-.235-6.785-3.097-7.042-6.704h.502c.257 3.31 3.045 5.97 6.54 6.203ZM3.426 7.75h-.5c.016-.215.042-.426.077-.634l.466.112-.033.132h.035c-.018.129-.033.259-.044.39ZM2.017 7.273l-.353-.353.433-.433.176.176.177.177-.433.433ZM4.65 6.92l-.353.353-.433-.433.176-.177.177-.176.433.433ZM19.084 8.975l-.428.428-.176-.177-.176-.176.427-.428.353.353Zm-2.628-.358.433.433-.176.176-.177.177-.432-.433.352-.353Z", fill: "currentColor" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "EuroExchange__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.736 .03)", d: "M0 0h19.28v15.94H0z" }))))); });

export { EuroExchange };
//# sourceMappingURL=EuroExchange.js.map
